module.exports = __webpack_public_path__ + "media/images/version_merge/steps_review_approval-2ae4ca77f15f74732f03f1c6693120d6.jpg";